<template lang="pug">
  div.exchange-goods-container
    //- 兑换商品面板
    .exchange-goods-panel-area(v-if="list.length > 0")
      ExchangeGoodsPanel(
        :exchangeGoodsList="list"
        :points="points"
        :chooseSkuId="chooseSkuId"
        :guideDesc="guideInfo.guidingDesc"
        @exchange="handleExchangeClick"
        @earnPoints="handleAnchorModule"
        @moreClick="handleMoreGoodsClick"
        @setCurrentExchangeInfo="(info) => currentExchangeInfo = info"
      )

    //- 兑换引导弹窗
    ExchangeGoodsPopup(
      :visible="popupVisible"
      :list="goodsPopupList"
      @close="handleClosePopup"
      @itemClick="handleGoodsItemClick"
    )
    //- 商品兑换弹窗
    ExchangePopup(
      :visible="exchangePopupVisible"
      :exchangeInfo="currentExchangeInfo"
      :points="points"
      :isShowGroupPayment="isShowGroupPayment"
      @close="handleExchangePopupClose"
      @success="handleExchangeSuccess"
      @bounty="$emit('bounty')"
      @earnPoints="handleAnchorModule"
      :popupSource=0
    )
    //- 玩法引导弹窗
    WelfarePlayGuide(
      :visible="playGuidePopupVisible"
      :info="playGuidePopupInfo"
      :newExchange="isShowNewExchangeGoods"
      @goodsClick="handleGoodsClick"
      @close="handlePlayGuideClose"
    )
</template>

<script>
import eventBus from '@/const/eventBus';
import { Storage } from '@/utils/storage';
import Loading from '@/components/loading';
import config from '@/const/config';
import { jumpUrl } from '@/utils/tools';
import {
  getExchangeGoodsList,
  exchangeGoodsListAdapter,
  playGuidePopupInfoAdapter,
  anchorToModule,
} from '../common/helper';
import ExchangeGoodsPopup from './exchange-goods-popup';
import ExchangePopup from './exchange-popup';
import WelfarePlayGuide from '../welfare-play-guide';
import ExchangeGoodsPanel from './exchange-goods-panel';
import {
  STORAGE_KEY_EXCHANGE_CHOOSE_SKU_ID,
  POPUP_WINDOW_KEY,
  PLAY_GUIDE_WINDOW_KEYS,
} from '../consts';


export default {
  name: 'ExchangeGoods',
  components: {
    ExchangeGoodsPopup,
    ExchangePopup,
    WelfarePlayGuide,
    ExchangeGoodsPanel,
  },
  props: {
    points: {
      type: Number,
      default: 0,
    },
    exchangeGoodsList: {
      type: Array,
      default: () => [],
    },
    rewardGuidingRules: {
      type: Array,
      default: () => [],
    },
    goodsCateInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // 商品状态 list | card
      status: 'list',
      // 兑换商品列表
      list: [],
      // 是否展示弹窗
      popupVisible: false,
      // 是否展示兑换弹窗
      exchangePopupVisible: false,
      // 当前点击兑换信息
      currentExchangeInfo: {},
      // 缓存/点击商品卡片信息
      exchangeGoodsCardInfo: {},
      // 锚点定时器
      anchorTimer: null,
      // 是否展示玩法引导弹窗
      playGuidePopupVisible: false,
      // 商品兑换弹窗列表
      goodsPopupList: [],
      // 玩法引导弹窗信息
      playGuidePopupInfo: {},
      // 当前选择的商品ID
      chooseSkuId: '',
      // 弹窗展示定时器
      popupTimer: null,
      // 兑换弹窗是否展示为奖励金+钱组合支付的按钮
      isShowGroupPayment: false,
    };
  },
  inject: ['popupWindowInfo', 'isWelfareApp'],
  computed: {
    // 是否展示新版兑换商品（暂时默认true）
    isShowNewExchangeGoods() {
      // const { exchangeAb } = this.goodsCateInfo || {};
      // return exchangeAb === EXCHANGE_GOODS_AB.TEST_GROUP;
      return true;
    },
    // 是否应该触发引导弹窗
    shouldTriggerGuidePopup() {
      const { showPopup } = this.goodsCateInfo || {};
      const popupInfo = this.popupWindowInfo() || {};
      return !!(showPopup && popupInfo.key);
    },
    guideInfo() {
      const { amount } = this.currentExchangeInfo || {};
      const num = amount - this.points;
      return this.rewardGuidingRules.find((item) => {
        if (item.maxNumber === -1) {
          return item.minNumber <= num;
        }
        return item.minNumber <= num && num <= item.maxNumber;
      }) || {};
    },
  },
  watch: {
    exchangeGoodsList(val) {
      this.list = val;
    },
    'goodsCateInfo.isCache': {
      handler() {
        // 设置兑换商品列表数据
        this.list = this.exchangeGoodsList;
        // 判断之前有无进行中的兑换商品
        this.judgeDefaultChooseGoods();
      },
      immediate: true,
    },
    shouldTriggerGuidePopup(shouldTrigger) {
      if (shouldTrigger) {
        this.handleGuidePopup();
      }
    },
  },
  mounted() {},
  destroyed() {
    if (this.popupTimer) {
      clearTimeout(this.popupTimer);
    }
  },
  methods: {
    // 关闭弹窗
    handleClosePopup() {
      this.popupVisible = false;
    },
    // 兑换商品点击
    handleGoodsItemClick(item, type) {
      this.exchangeGoodsCardInfo = item;

      switch (type) {
        case 'list':
          this.handleExchangeClick(item);
          break;
        case 'card':
          this.handleExchangeClick(item);
          break;
        case 'popup':
          this.status = 'card';
          this.chooseSkuId = item.skuId;
          this.handleClosePopup();
          try {
            // 缓存点击的商品信息
            Storage.setItem(STORAGE_KEY_EXCHANGE_CHOOSE_SKU_ID, item.skuId);
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log('handleGoodsItemClick error', error);
          }
          break;
        default:
          break;
      }
    },
    // 切换商品点击
    async handleSwitchClick() {
      Loading.show();
      // 获取最新兑换商品列表
      const exchangeGoodsList = await getExchangeGoodsList(this.goodsCateInfo);
      if (exchangeGoodsList.length) {
        this.list = exchangeGoodsList;
        this.goodsPopupList = exchangeGoodsList;
      }
      Loading.close();
      this.popupVisible = true;
    },
    // 锚点模块
    handleAnchorModule(guideInfo) {
      this.anchorTimer = anchorToModule(guideInfo || this.guideInfo, this.anchorTimer);
    },
    // 关闭兑换弹窗
    handleExchangePopupClose() {
      this.exchangePopupVisible = false;
    },
    // 确认兑换成功
    handleExchangeSuccess() {
      this.exchangePopupVisible = false;

      if (this.status === 'card') {
        this.status = 'list';
      }

      // 清除选中商品缓存
      Storage.removeItem(STORAGE_KEY_EXCHANGE_CHOOSE_SKU_ID);
    },
    // 兑换商品卡片点击处理
    handleExchangeClick(item) {
      const { amount } = item || {};
      this.currentExchangeInfo = item;
      this.isShowGroupPayment = !(amount <= this.points);
      this.exchangePopupVisible = true;
    },
    // 判断是存在默认选中商品
    judgeDefaultChooseGoods() {
      const chooseSkuId = Storage.getItem(STORAGE_KEY_EXCHANGE_CHOOSE_SKU_ID);
      if (chooseSkuId) {
        const info = this.exchangeGoodsList.find(
          (item) => item.skuId === chooseSkuId,
        );

        if (!info) return;
        this.exchangeGoodsCardInfo = info;
        this.status = 'card';
        this.chooseSkuId = chooseSkuId;
      }
    },
    // 商品卡片点击
    handleGoodsCardClick(item) {
      const { skuId } = item || {};
      jumpUrl(
        `https://m.hellobike.com/AppPlatformH5/${
          config.env !== 'pro' ? `${config.env}/` : ''
        }latest/pr_index_bounty_detail_default.html#/bounty/detail/${
          skuId
        }?adsource=4`,
      );
    },
    // 处理引导弹窗
    handleGuidePopup() {
      const { key, data } = this.popupWindowInfo() || {};
      if (!data) return;

      // 处理玩法引导弹窗
      if (PLAY_GUIDE_WINDOW_KEYS.includes(key)) {
        this.handlePlayGuideWindow({ data });
      }

      // 处理新手引导弹窗
      if (this.status !== 'card' && key === POPUP_WINDOW_KEY.beginner_education_window) {
        const { goodsList = [] } = data;
        if (goodsList.length === 0) return;

        this.popupTimer = setTimeout(() => {
          if (this.popupTimer) {
            clearTimeout(this.popupTimer);
          }
          this.popupTimer = null;
          this.popupVisible = true;
          this.goodsPopupList = exchangeGoodsListAdapter(goodsList);
        }, 200);
      }
    },
    // 关闭玩法引导弹窗
    handlePlayGuideClose() {
      eventBus.$emit('playGuideFinished');
      this.playGuidePopupVisible = false;
    },
    // 玩法引导弹窗商品点击
    handleGoodsClick() {
      const { skuId } = this.playGuidePopupInfo || {};
      if (skuId) {
        const info = this.exchangeGoodsList.find(
          (item) => item.skuId === skuId,
        );
        if (!info) return;
        this.exchangeGoodsCardInfo = info;
        this.status = 'card';
        this.chooseSkuId = skuId;

        try {
          // 缓存点击的商品信息
          Storage.setItem(STORAGE_KEY_EXCHANGE_CHOOSE_SKU_ID, skuId);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log('handleGoodsClick error', error);
        }
      }
    },
    // 更多兑换点击
    handleMoreGoodsClick() {
      const el = document.getElementById('welfare_bountyExchange');
      if (!el) return;
      const { offsetTop } = el;
      window.scrollTo({
        top: offsetTop - 100,
        behavior: 'smooth',
      });
    },
    // 处理玩法引导弹窗展示逻辑
    handlePlayGuideWindow(options) {
      const { data } = options || {};

      // 查找配置商品是否在兑换商品列表中
      const idx = this.exchangeGoodsList.findIndex(
        (item) => item.skuId === data.skuId,
      );
      if (idx === -1) return;

      if (this.isShowNewExchangeGoods || this.status !== 'card') {
        this.popupTimer = setTimeout(() => {
          if (this.popupTimer) {
            clearTimeout(this.popupTimer);
          }
          this.popupTimer = null;
          this.playGuidePopupVisible = true;
          this.playGuidePopupInfo = playGuidePopupInfoAdapter(data);
        }, 200);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.exchange-goods-list-area {
  margin-top: 0.12rem;
}

.exchange-goods-card-area {
  margin-top: 0.23rem;
  padding: 0 0.12rem;
}

.exchange-goods-panel-area {
  margin-top: 0.12rem;
  padding: 0 0.08rem;
}
</style>
